import { formatEther } from 'viem'

import { formatTicks } from './string.helpers'

export const floorNumber = (n) => Math.floor(n)

export const percentageOfCompletion = (current, total) => {
  const completed = (current / total) * 100
  return Math.round(completed)
}

export const formatToDecimals = (n, m) => n.toFixed(m)

export const formatCurrencyValue = (value, maxDigits = 3) => {
  return value ? parseFloat(formatToDecimals(parseFloat(value), maxDigits)) : 0
}

export const formatCurrencyShort = (value) => {
  return formatTicks(formatCurrencyValue(value))
}

export const formatCurrency = (value) => {
  return formatTicks(value)
}

export const formatDeposit = (value) => {
  return formatTicks(floorNumber(value))
}

export const formatAmount = (value) => {
  return value ? parseFloat(formatEther(value)) : 0
}

export const sumOfArrayElements = (elements) => {
  if (elements && elements.length > 0) {
    return elements.reduce((a, b) => a + b, 0)
  } else {
    return 0
  }
}
